import { render, staticRenderFns } from "./ContentPadding.vue?vue&type=template&id=5bfd633f&scoped=true&"
import script from "./ContentPadding.vue?vue&type=script&lang=js&"
export * from "./ContentPadding.vue?vue&type=script&lang=js&"
import style0 from "./ContentPadding.vue?vue&type=style&index=0&id=5bfd633f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfd633f",
  null
  
)

export default component.exports